import { stringify } from 'qs';
import request from '../../utils/request';

export async function submit(params) {
  return request('/api/blade-system/watch-authority/submit', {
    method: 'POST',
    body: params,
  });
}

export async function detail(params) {
  return request(`/api/blade-system/watch-authority/detail?${stringify(params)}`);
}

export async function check(params) {
  return request(`/api/blade-system/watch-authority/check?${stringify(params)}`);
}

export async function tree(params) {
  return request(`/api/blade-system/role/tree?${stringify(params)}`);
}
